import { GetOrganizationDto } from '../dtos/getOrganizationDto.interface';

export interface OrganizationViewModel
    extends Omit<GetOrganizationDto, 'countryISO31661Alpha2Code' | 'fcpActivationDetails' | 'cpmmActivationDetails' | 'usageData'> {
    country: string;
    fcpActivationStartDate: string;
    fcpSubscription: string;
    surveyData: string;
    cpmmActivationState: string;
    usageData: string;
}
